import { AnalyticsClickEvents } from "../../../../types/analytics";

export const title = "A rate designed just for you";
export const cta: AnalyticsClickEvents = "See my rate estimate";
export const disclaimer =
  "* Finance provided by Wisr Finance Pty Ltd ACN 119 503 221 Australian Credit Licence 458572 to approved applicants. Terms and conditions apply. This does not constitute an offer for credit nor does it guarantee that an offer for any product will be made to you.";
